import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { isExpired, decodeShortDescription } from "../../../utils/jobHelper";

const DraftApplicationListItem = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const redirectToDraft = (draft) => history.push("/applications/edit/" + draft.job.id);

  const { draft } = props;
  const expired = isExpired(draft.job.jobAdvertExpiryDate);
  return (
    <div className="dashboard-list-item">
      <div className="row">
        <div className="col-xs-12 col-sm-7 col-md-8">
          <div className="row">
            <div className="col-xs-12 col-sm-7">
              <h4>
                <a href={draft.job.jobUrl} title={draft.job.jobTitle}>
                  {draft.job.jobTitle}
                </a>
              </h4>
            </div>
            <div className="col-xs-12 col-sm-5 text-right">
              <strong className="black-txt qjicon location-icon">
                {[draft.job.jobState, draft.job.jobCity].join(" - ")}
              </strong>
              <div className="clearfix visible-xs-block">
                <strong className="qjicon time-icon">
                  {expired ? t("Verb.Closed") : t("Verb.Closes")}{" "}
                  {t("ShortDateValue", { date: draft.job.jobAdvertExpiryDate })}
                </strong>
              </div>
            </div>
          </div>
          <div className="row dashboard-list-item--content">
            <div className="col-xs-12 col-sm-8 dark-txt">{decodeShortDescription(draft.job.jobShortDescription)}</div>
            <div className="col-xs-12 col-sm-4 text-right img-wrap">
              {draft.job.jobLogo ? (
                <img className="img-responsive" src={draft.job.jobLogo} alt={draft.job.jobTitle} />
              ) : null}
            </div>
          </div>
        </div>
        <div className="col-xs-12 col-sm-5 col-md-4 dashboard-list-item--side-col">
          <div className="clearfix part-wrap">
            <strong className="qjicon time-icon">
              {expired ? t("Verb.Closed") : t("Verb.Closes")}{" "}
              {t("ShortDateValue", { date: draft.job.jobAdvertExpiryDate })}
            </strong>
          </div>
          <div className="clearfix part-wrap part-wrap--button">
            <Button
              data-testid="handleEditTest"
              size="lg"
              variant="info outline-light"
              onClick={() => redirectToDraft(draft)}
              disabled={!draft.editable}>
              {t("Button.Edit")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DraftApplicationListItem;
